export const DEFAULT_SWITCH_TO_SESSION_TIMER_WAIT_INTERVAL = 1;